import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux'
import { popUpMenuChange, 
        popUpMessageChange,
        selectedCardsGroupsChange,
        setAddPayment } from '../../actions/index'

import Icon from '@mdi/react';
import { mdiCashPlus  } from '@mdi/js';

import { _ } from '../../functions/translator'
import { showMessage } from '../../functions/popUpMessage';

class AddPaymentButton extends React.Component{
          
    handleClick = () => {
        if (this.props.userRole.sensitive_data) {
            this.props.setAddPayment({ show: true, cardsGroupIds: this.props.cardsGroupIds })
        } else {
            showMessage(this.props, _('No tienes permisos para agregar porcentajes pagados') + '.');
        }
        this.props.popUpMenuChange({ show: false })
        this.props.selectedCardsGroupsChange([])
    }

    render(){   
        
        return (
            <div>
                <div className="popup-menu-button card-color" ref={ref => this.button = ref} onClick={this.handleClick}>
                    <div className='d-inline-flex'>
                        <Icon path={ mdiCashPlus } size='30px' color='white' style={{marginTop: 10, marginLeft: 13, marginRight: 10}}/>
                        <p>{ _('Marcar como Pagado') }</p>
                    </div>
                </div>
            </div>
        );

    }
}

function mapStateToProps( state ){
    return {
        popUpMenu : state.popUpMenu,
        userRole : state.userRole,
    }
}

function matchDispatchToProps( dispatch ){
    return bindActionCreators({
        popUpMenuChange : popUpMenuChange,
        popUpMessageChange : popUpMessageChange,
        selectedCardsGroupsChange : selectedCardsGroupsChange,
        setAddPayment : setAddPayment,
    }, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(AddPaymentButton)